export const site_url='https://newadmin.apmsmarthub.com/api';
export const site_url_img='https://newadmin.apmsmarthub.com/public/storage';

/** AES-GCM key material for referral `ref` in signup URLs (client-visible; use REACT_APP_REFERRAL_REF_SECRET in production). */
export const referral_ref_secret =
  (typeof process !== 'undefined' && process.env.REACT_APP_REFERRAL_REF_SECRET) ||
  'apm-customer-referral-ref-secret-change-via-env';
